import { ref, watch } from 'vue'
import { createGlobalState } from '@vueuse/core'
import { useRouteHash } from '@vueuse/router'

import { CreateUpdateCompetitionDto, gameService } from '@/services/game.service'

export const useGame = createGlobalState(() => {
  const viewPointHistory = ref('')
  const viewHowToScore = ref('')
  const viewRequestPoints = ref('')
  const preselectedEventId = ref('')

  const activeModal = useRouteHash('')

  const addGame = async (game: CreateUpdateCompetitionDto) => {
    try {
      const result = await gameService.competitions.create(game)
      return result
    } catch (error) {
      console.error(error)
      throw error
    }
  }

  const updateGame = async (id: string, game: CreateUpdateCompetitionDto) => {
    try {
      const result = await gameService.competitions.update(id, game)
      return result
    } catch (error) {
      console.error(error)
      throw error
    }
  }

  const deleteGame = (id: string) => {
    //
  }

  const getGame = (id: string) => {
    //
    return {}
  }

  watch(
    () => viewPointHistory.value,
    (n, o) => { if (o && !n && activeModal.value === '#point-history') activeModal.value = '' }
  )

  watch(
    () => viewHowToScore.value,
    (n, o) => { if (o && !n && activeModal.value === '#how-to-score') activeModal.value = '' }
  )

  watch(
    () => viewRequestPoints.value,
    (n, o) => { if (o && !n && activeModal.value === '#request-points') activeModal.value = '' }
  )

  return {
    viewPointHistory,
    openPointHistory: (competitionId?: string) => {
      viewPointHistory.value = competitionId ?? 'view'
      // activeModal.value = '#point-history'
    },
    viewHowToScore,
    openHowToScore: (competitionId?: string) => {
      viewHowToScore.value = competitionId ?? 'view'
      // activeModal.value = '#how-to-score'
    },
    viewRequestPoints,
    preselectedEventId,
    openRequestPoints: (competitionId?: string, domainEventId?: string) => {
      preselectedEventId.value = domainEventId || ''
      viewRequestPoints.value = competitionId ?? 'view'
      // activeModal.value = '#request-points'
    },
    addGame,
    updateGame,
    deleteGame,
    getGame
  }
})
